import type { z } from "zod"

interface DateRangeValues {
  endDate: string
  startDate: string
}

/** Adds the invalid end date issue when a date range ends before it starts */
export const refineDateRange = (
  values: DateRangeValues,
  ctx: z.RefinementCtx
): void => {
  if (values.endDate < values.startDate) {
    ctx.addIssue({
      code: "custom",
      origin: "invalid_end_date",
      path: ["endDate"],
    })
  }
}
